import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=1d7d7e7a&scoped=true&"
import script from "./logistics.vue?vue&type=script&lang=js&"
export * from "./logistics.vue?vue&type=script&lang=js&"
import style0 from "./logistics.vue?vue&type=style&index=0&id=1d7d7e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7d7e7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7d7e7a')) {
      api.createRecord('1d7d7e7a', component.options)
    } else {
      api.reload('1d7d7e7a', component.options)
    }
    module.hot.accept("./logistics.vue?vue&type=template&id=1d7d7e7a&scoped=true&", function () {
      api.rerender('1d7d7e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pickUp/logistics.vue"
export default component.exports